import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "Virtual Market 2 \"VIRTUAL MUSEUM\""
const scope = "VR空間体験設計・制作"
const str1 = "VR法人HIKKYが主催する世界最大のバーチャル展示即売会「バーチャルマーケット2」の会場のひとつ、「バーチャルミュージアム」の空間体験ディレクション、制作を行った。"
const str2 = "3Dボロノイ図をランドスケープに見立て、各セルの接辺上に色を刻々と移動させることで、中心のないフラットな空間で情報が行き交う「インターネット上の祝祭」の風景を生み出している。"

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.vm01.childImageSharp.original.src}
          pageimgw={data.vm01.childImageSharp.original.width}
          pageimgh={data.vm01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/vm01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/vm02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/vm03.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/vm04.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/vm05.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/vm06.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/vm07.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  vm01: file(relativePath: {eq: "vm01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
